import { apiFetch } from "@/lib/api/fetcher";

const PROFILE_PATH = "/v1/users/user-profile-info?fields=cohortId";
const UPDATE_COHORT_PATH = "/v1/users/update-cohort";
const UPDATE_RECENT_COHORT_PATH = "/v1/users/update-recent-cohort";

/** The env value is quoted in some deployments; strip the quotes so the id is usable as-is. */
export const SIGNUP_COHORT_ID = (process.env.NEXT_PUBLIC_COHORT_ID ?? "")
  .trim()
  .replace(/^['"]|['"]$/g, "");

/**
 * Mirrors gcms-admin's `ensurePiWebCohortAssigned` (src/widgets/pi-web/cohort.ts). The SDK's
 * `cohortId` prop only applies to brand-new registrations, so someone who signed up on another PW
 * surface without picking a cohort still arrives here without one — and study-v2 then forces
 * /study-v2/cohort-selection. Assign the Pi default cohort to those users before redirecting.
 */
export async function ensureSignupCohortAssigned(): Promise<void> {
  if (!SIGNUP_COHORT_ID) {
    return;
  }

  try {
    const profile = await apiFetch<{ data?: { cohortId?: string } }>(
      PROFILE_PATH,
    );

    // Never overwrite a cohort picked on another PW property.
    if (profile?.data?.cohortId) {
      return;
    }

    const body = { cohortId: SIGNUP_COHORT_ID };

    await apiFetch(UPDATE_COHORT_PATH, { method: "PUT", body });
    await apiFetch(UPDATE_RECENT_COHORT_PATH, { method: "PUT", body });
  } catch (error) {
    // Non-fatal: worst case the user sees the cohort-selection page once.
    console.error("[auth] Unable to assign the default Pi cohort", error);
  }
}
